import seriesHelpers from '@/helpers/seriesHelpers'
import api from './api'

class ReadingsService {
    getSiteLatestReadings(siteId) {
        return api.get(`/sites/${siteId}/latest_readings`)
    }

    getSiteMeasuringPointFields(siteId) {
        return api.get(`/sites/${siteId}/mp_fields`)
    }

    getApartmentMonthStatistics(apartmentId) {
        return api.get(`/tenant/apartments/${apartmentId}/month-statistics`)
    }

    getApartmentChartStatistics(apartmentId, params) {
        return api.get(`/tenant/apartments/${apartmentId}/chart-statistics`, { params })
    }

    async getApartmentStatisticsData(apartmentId, data) {
        let params = {
            start: data.start.toISOString(),
            series: data.series,
            period: data.period,
            interval: data.interval,
        }

        const telegrams = (await api.get(`/apartments/${apartmentId}/statistics`, { params })).data

        return telegrams
    }

    async getSiteStatusStatistics(siteId, now) {
        return await api.get(`/sites/${siteId}/status_statistics`, { params: { now }})
    }

    getSiteStatistics(siteId, params) {
        return api.get(`/sites/${siteId}/statistics`, { params })
    }

    getDeviceReadings(deviceId, start, stop, noLimit = false) {
        let params = { start, stop }
        if (noLimit) {
            params.no_limit = 1
        }
        return api.get(`/devices/${deviceId}/readings`, { params })
    }

    insertDeviceReading(deviceId, timestamp, values, source = null) {
        const data = {
            timestamp,
            values,
            source,
        }
        return api.post(`/devices/${deviceId}/readings`, data)
    }

    deleteDeviceReading(deviceId, timestamp) {
        return api.delete(`/devices/${deviceId}/readings/${timestamp}`)
    }

    updateDeviceReading(deviceId, timestamp, values, source = null) {
        const data = {
            timestamp,
            values,
            source,
        }
        console.log(data    )
        return api.put(`/devices/${deviceId}/readings`, data)
    }
}

export default new ReadingsService()